module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-bold-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-bold-webfont.eot
// module id = 137
// module chunks = 3